class ShadeFinderQuizModelFits extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupModelProductSelect()
    this.setupContinueListeners()
    this.setupBackListeners()
  }

  setupModelProductSelect () {
    const modelItems = document.querySelectorAll('.sec-QuizContent_ModelBlockRadioInput')

    modelItems.forEach(modelItem => {
      modelItem.addEventListener('click', () => {
        const modelItemAttributeProduct = modelItem.getAttribute('data-skintone-main-product')
        const modelItemAttributeProductVariant = modelItem.getAttribute('data-skintone-main-product-variant')
        const continueBtns = document.querySelectorAll('[data-product-match-section-trigger]')

        continueBtns.forEach(continueBtn => {
          continueBtn.setAttribute('data-skintone-main-product', modelItemAttributeProduct)
          continueBtn.setAttribute('data-skintone-main-product-variant', modelItemAttributeProductVariant)
          continueBtn.removeAttribute('disabled')
        })
      })
    })
  }

  setupContinueListeners () {
    const continueBtns = document.querySelectorAll('[data-product-match-section-trigger]')

    continueBtns.forEach(continueBtn => {
      continueBtn.addEventListener('click', () => {
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-product-match').classList.add('is-active')

        const mainProduct = continueBtn.getAttribute('data-skintone-main-product')
        const mainProductVariant = continueBtn.getAttribute('data-skintone-main-product-variant')

        const productMatchSection = document.querySelector('shade-finder-quiz-product-match')
        const productMatchSectionItems = productMatchSection.querySelectorAll('.prd-CardSimple')

        const productMatchSectionGalleries = productMatchSection.querySelectorAll('.sec-QuizContent_Image-GridGallery')

        const productMatchSectionAltShades = productMatchSection.querySelectorAll('.sec-QuizContent_AlternativeShades')

        productMatchSectionItems.forEach(productMatch => {
          const matchProduct = productMatch.getAttribute('data-skintone-main-product')
          const matchProductVariant = productMatch.getAttribute('data-skintone-main-product-variant')
          const matchProductURL = productMatch.getAttribute('data-skintone-main-product-variant-url')

          if (mainProduct === matchProduct && mainProductVariant === matchProductVariant) {
            productMatch.classList.add('is-active')

            const productResultElements = document.querySelectorAll('.kla-Form-ProductResult')
            productResultElements.forEach(productResult => {
              productResult.setAttribute('data-klaviyo-shade-finder-product-result', matchProduct)
              productResult.setAttribute('data-klaviyo-shade-finder-variant-result', matchProductVariant)
              productResult.setAttribute('data-klaviyo-shade-finder-product-url-result', matchProductURL)
            })
          } else {
            productMatch.classList.remove('is-active')
          }

          productMatchSectionGalleries.forEach(galleryMatch => {
            const matchProductGallery = galleryMatch.getAttribute('data-skintone-shade-gallery')

            // This condition ensures that the gallery for the current product is shown
            if (mainProductVariant === matchProductGallery) {
              galleryMatch.classList.add('is-active')
            } else {
              galleryMatch.classList.remove('is-active')
            }
          })

          productMatchSectionAltShades.forEach(altShadeMatch => {
            const matchAltShadesResults = altShadeMatch.getAttribute('data-skintone-shade-alternatives')

            // This condition ensures that alternative shades for the current product are shown
            if (mainProductVariant === matchAltShadesResults) {
              altShadeMatch.classList.add('is-active')
            } else {
              altShadeMatch.classList.remove('is-active')
            }
          })
        })

        window.scrollTo(0, 0)
      })
    })
  }

  setupBackListeners () {
    const backBtns = document.querySelectorAll('[data-modelfit-section-back-trigger]')

    backBtns.forEach(backBtn => {
      backBtn.addEventListener('click', () => {
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-skintone').classList.add('is-active')

        const radioInputs = document.querySelectorAll('.sec-QuizContent_SkintoneBlockRadioInput')
        radioInputs.forEach(input => {
          input.checked = false
        })

        const continueBtns = document.querySelectorAll('[data-modelfit-section-trigger]')
        continueBtns.forEach(continueBtn => {
          continueBtn.setAttribute('data-skintone-main-product', '')
          continueBtn.setAttribute('data-skintone-main-product-variant', '')
          continueBtn.setAttribute('disabled', '')
        })

        window.scrollTo(0, 0)
      })
    })
  }
}

if (!customElements.get('shade-finder-quiz-modelfits')) {
  customElements.define('shade-finder-quiz-modelfits', ShadeFinderQuizModelFits)
}
